import React from 'react';

import { CustomOfferFormValues } from '@/typings/formValues';
import { Control, Controller, FieldErrors } from 'react-hook-form';

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

type CustomOfferInternalDiscountFieldProps = {
  control: Control<CustomOfferFormValues>;
  errors: FieldErrors<CustomOfferFormValues>;
  isSubmitting: boolean;
  isReadOnly?: boolean;
  gridSize?: React.ComponentProps<typeof Grid>['size'];
  textFieldSize?: 'small' | 'medium';
};

const INTERNAL_DISCOUNT_HELPER_TEXT =
  'Does not change pricing or payment amounts. Saved on this custom offer for admin reference only.';

export default function CustomOfferInternalDiscountField({
  control,
  errors,
  isSubmitting,
  isReadOnly = false,
  gridSize = { xs: 6, md: 3 },
  textFieldSize = 'medium',
}: CustomOfferInternalDiscountFieldProps) {
  const isFieldDisabled = isSubmitting || isReadOnly;

  return (
    <Grid size={gridSize}>
      <Controller
        name="payment_metadata.internal_discount_tracking"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            value={field.value ?? ''}
            onChange={(e) => {
              if (isReadOnly) {
                return;
              }
              const value = e.target.value;
              if (value === '' || /^-?\d*$/.test(value)) {
                field.onChange(value);
              }
            }}
            label="Discount (internal tracking)"
            helperText={errors.payment_metadata?.internal_discount_tracking?.message ?? INTERNAL_DISCOUNT_HELPER_TEXT}
            error={!!errors.payment_metadata?.internal_discount_tracking}
            fullWidth
            size={textFieldSize}
            disabled={isFieldDisabled}
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: { inputMode: 'numeric', readOnly: isReadOnly },
            }}
            data-testid="internal-discount-tracking"
          />
        )}
      />
    </Grid>
  );
}
